import React from "react";
import { DropdownButton } from "../Button";

import { connect } from "react-redux";
import transactionStatus from "../../constants/transactionStatus";
import { Checkbox } from "../Input";
import { onAddFilter } from "../../actions/Filters";

class TransactionStatus extends React.Component {
  onCheck(el) {
    this.props.dispatch(
      onAddFilter({
        transactionStatus: el,
      })
    );
  }
  render() {
    return (
      <DropdownButton
        leftIcon={this.props.icon}
        text={this.props.title}
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        selectedData={this.props?.filters?.transactionStatus}
        clickOutside
      >
        {transactionStatus(this.props.defaultLanguage).map((el, i) => {
          return (
            <Checkbox
              label={el.label}
              key={i}
              onCheck={() => this.onCheck(el)}
              checked={
                this.props?.filters?.transactionStatus?.value === el.value
              }
            />
          );
        })}
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(TransactionStatus);
